import type { Track } from '../types/Track';

type MusicBrainzRecording = { id: string; title?: string; 'first-release-date'?: string; tags?: Array<{ name?: string; count?: number }>; releases?: Array<{ id: string; title?: string; date?: string }> };
type MusicBrainzResponse = { recordings?: MusicBrainzRecording[] };

type MusicMetadata = Partial<Pick<Track, 'title' | 'channelTitle' | 'albumName' | 'releaseYear' | 'genre' | 'tags' | 'thumbnailUrl' | 'maxresThumbnailUrl'>> & { musicBrainzId?: string };

export async function fetchMusicMetadata(track: Track): Promise<MusicMetadata | null> {
  const params = new URLSearchParams({
    query: `recording:"${track.title}" AND artist:"${track.channelTitle}"`,
    fmt: 'json',
    limit: '5',
  });
  const response = await fetch(`https://musicbrainz.org/ws/2/recording?${params.toString()}`, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error(response.status === 503 ? 'MusicBrainz is busy. Try again shortly.' : 'Music metadata lookup failed.');
  const data = await response.json() as MusicBrainzResponse;
  const recording = data.recordings?.[0];
  if (!recording) return null;
  const release = recording.releases?.[0];
  const releaseYear = (recording['first-release-date'] || release?.date || '').slice(0, 4);
  const tags = (recording.tags || []).sort((a, b) => (b.count || 0) - (a.count || 0)).map(tag => tag.name).filter((tag): tag is string => Boolean(tag)).slice(0, 8);
  const artworkUrl = release?.id ? `https://coverartarchive.org/release/${release.id}/front-500` : undefined;
  return { title: recording.title || track.title, albumName: release?.title, releaseYear: releaseYear || undefined, genre: tags[0] || track.genre || 'Music', tags: tags.length ? tags : track.tags, thumbnailUrl: artworkUrl || track.thumbnailUrl, maxresThumbnailUrl: artworkUrl || track.maxresThumbnailUrl, musicBrainzId: recording.id };
}
